// Type
const Listtype = () => import('@/views/campaign-management/type/index')
const Formtype = () => import('@/views/campaign-management/type/form')

export default {
    path: 'type',
    redirect: '/type',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'type',
            component: Listtype,
            meta: {
                link: 'type',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Campaign Type', active: true },
                ],
                pageTitle: 'Campaign Type'
            }
        },
        {
            path: 'add',
            name: 'addtype',
            component: Formtype,
            meta: {
                link: 'type',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Campaign Type', url: '/type' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Campaign Type'
            }
        },
        {
            path: 'edit/:id',
            name: 'edittype',
            component: Formtype,
            meta: {
                link: 'type',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Campaign Type', url: '/type' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Campaign Type'
            }
        },
    ]
}